import Box from '@mui/material/Box';

import { AuthProvider } from '@/components/providers/AuthProvider';
import { TopSpot } from '@/pages/TopSpot';

export const TopSpotLayout = () => (
    <AuthProvider>
        <Box sx={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
            <TopSpot />
        </Box>
    </AuthProvider>
);
